export const SAVE_ALL_BILLS = 'SAVE_ALL_BILLS'